module.exports = __webpack_public_path__ + "static/TT1444_TW-MKD02a-90035dadef8e5fba4bead7f2552dcbcd.png";